import type { Metadata } from "next";

export const SITE_URL = "https://convertmdtopdf.com";
export const SITE_NAME = "Convert MD to PDF";

/** Fallback / root layout description (also used in default Open Graph). */
export const SITE_DESCRIPTION =
  "Convert Markdown to PDF online with a free live preview editor. No watermark, no sign-up.";

/**
 * Stable public/ favicon URLs for Google Search and browsers.
 * Avoid App Router file icons — Next fingerprints those with ?hash query strings,
 * which conflicts with Google's "stable favicon URL" guidance.
 */
export const SITE_ICONS = {
  icon: [
    { url: "/favicon.ico", sizes: "48x48", type: "image/x-icon" },
    { url: "/icon-48.png", sizes: "48x48", type: "image/png" },
    { url: "/icon-96.png", sizes: "96x96", type: "image/png" },
    { url: "/icon.svg", sizes: "any", type: "image/svg+xml" },
  ],
  apple: [{ url: "/apple-touch-icon.png", sizes: "180x180", type: "image/png" }],
} satisfies NonNullable<Metadata["icons"]>;
